import { CombinedGraphQLErrors } from "@apollo/client/errors";
import { useCallback } from "react";

export function isStaleVersionError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) return false;
  return error.errors.some((e) => e.extensions?.code === "STALE_VERSION");
}

const useStaleVersionHandler = (onConflict: () => void) =>
  useCallback(
    (error: unknown): boolean => {
      if (!isStaleVersionError(error)) return false;
      onConflict();
      return true;
    },
    [onConflict],
  );

export default useStaleVersionHandler;
